import { CSSProperties, FC, ReactNode, useMemo } from "react";
import { borderButton, surfaceReverse } from "./Colors";

export const IconButton: FC<{
    borderless?: boolean;
    disabled?: boolean;
    icon: ReactNode;
    onClick: () => void;
    sx?: CSSProperties;
    tabIndex?: number;
}> = (props) => {
    const { borderless, disabled, icon, sx, tabIndex, onClick } = props;

    const styles = useMemo(() => {
        return {
            alignItems: "anchor-center",
            backgroundColor: surfaceReverse,
            border: borderless ? "none" : `1px solid ${borderButton}`,
            borderRadius: "100px",
            cursor: disabled ? null : "pointer",
            display: "flex",
            gap: "8px",
            height: "36px",
            padding: "8px",
            width: "36px",
            opacity: disabled ? 0.4 : 1,
            ...sx,
        };
    }, [borderless, disabled, sx]);

    return (
        <button tabIndex={tabIndex} disabled={disabled} style={styles} onClick={onClick}>
            {icon}
        </button>
    );
};
